import { useTranslation } from 'react-i18next'
import { Banknote, DoorOpen } from 'lucide-react'
import { useDashboard } from '@/hooks/useDashboard'
import { formatBaht } from '@/lib/money'
import KpiTileGrid from './KpiTileGrid'

// Two tiles in the same style as the business snapshot above them (owner,
// 2026-09-29: separate cards, no description lines). The figures keep their
// satang: a rent roll is not rounded.
export function RentRollSummary({ selectedPropertyId }: { selectedPropertyId: number | null }) {
  const { t } = useTranslation('reports')
  const { data, isLoading } = useDashboard(selectedPropertyId)
  const revenue = data?.revenue

  // An older API has no rent figures. Do not present missing values as zero.
  if (!isLoading && revenue?.rent_roll === undefined && revenue?.vacancy_gap === undefined) return null

  return (
    <div data-testid="rent-roll-summary">
      <KpiTileGrid
        columns={2}
        isLoading={isLoading}
        tiles={[
          {
            id: 'rent_roll', labelKey: 'index.rent_roll', label: t('index.rent_roll'),
            value: formatBaht(revenue?.rent_roll), icon: Banknote, 'data-testid': 'summary-rent_roll',
          },
          {
            id: 'vacancy_gap', labelKey: 'index.vacancy_gap', label: t('index.vacancy_gap'),
            value: formatBaht(revenue?.vacancy_gap), icon: DoorOpen, 'data-testid': 'summary-vacancy_gap',
          },
        ]}
      />
    </div>
  )
}
